import type { Mouvement } from '@mairistem/comptabilite';
import ProfilEcritureFactory from '../../classes/mouvements/profilEcriture/ProfilEcritureFactory';
import PROFIL_ECRITURE from '../../constants/mouvements/codeProfilEcritures';
import type ProfilEcriture from '../../interfaces/pieces/mouvements/profilEcriture';

export const isProfilLibre = (code: string) => {
	return (
		PROFIL_ECRITURE.DEPENSE.SAI_LIB === code ||
		PROFIL_ECRITURE.RECETTE.SAI_LIB === code
	);
};

export const filterProfilsForMouvement = (
	profilsToFilter: ProfilEcriture[],
	mouvement: Mouvement,
): ProfilEcriture[] => {
	// Si le bordereau n'a pas encore été selectionné, on retourne toute la liste
	if (!mouvement?.bordereau?.typePes) return profilsToFilter;

	return profilsToFilter.filter((p) => {
		// Les saisies libres sont à afficher
		if (isProfilLibre(p.code)) {
			return true;
		}

		const pe = ProfilEcritureFactory.newInstance(p.code, mouvement);
		return pe.typeBordereau === mouvement?.bordereau?.typePes;
	});
};
